import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-region-auto-complete',
  templateUrl: './region-auto-complete.component.html',
  styleUrls: ['./region-auto-complete.component.scss'],
})
export class RegionAutoCompleteComponent implements OnInit {
  @Input() other: boolean;
  @Input() selectedRegion: any;
  @Input() label: string = '';
  @Input() defaultValue: string = '';
  @Output() select = new EventEmitter<any>();
  @Input() items: any[] = [];
  value: string = '';
  cities: any[] = [];
  notMerged = true;
  skip = false;
  exeptionTerms = { hay: 'cite' };
  searchTerm = '';
  noResults = true;
  filteredItems: any[] = [];
  exceptionTerms = { hay: 'cite' };

  constructor() {
    console.log('this.defaultValue:', this.defaultValue);
  }

  ngOnInit(): void {
    this.value = this.defaultValue;

    console.log('this.selectedRegion:', this.selectedRegion);

    if (!this.items.length && this.selectedRegion) {
      this.mergeCitiesAndLocalities();
    }
  }

  mergeCitiesAndLocalities(): void {
    const cities: { name: string }[] = [];
    const citiesNames: { name: string }[] = [];
    const uniqueCities = new Set<string>();

    this.selectedRegion.cities.forEach((city) => {
      const cityName = city['Name_FR'];
      citiesNames.push({ name: cityName });

      city['locations'].forEach((locality) => {
        const fullName = `${city['Name_FR']}, ${locality['Name_FR']}`;
        if (!uniqueCities.has(fullName)) {
          cities.push({ name: fullName });
          uniqueCities.add(fullName);
        }
      });

      if (!uniqueCities.has(cityName)) {
        cities.push({ name: cityName });
        uniqueCities.add(cityName);
      }
    });

    this.items = cities;
    this.cities = citiesNames;
    this.filteredItems = [...cities]; // Garde une copie des villes/localités disponibles
    this.notMerged = false;
  }

  customSearchFn(term: string, item: any): boolean {
    this.searchTerm = term;
    if (!term || this.skip) return true;

    if (this.notMerged) {
      this.mergeCitiesAndLocalities();
    }
    const exception = this.exceptionTerms[term.toLowerCase()];

    // Filtrer les éléments correspondants
    const filteredItems = this.items.filter(
      (_item) =>
        _item.name.toLowerCase().includes(term.toLowerCase()) ||
        _item.name.toLowerCase().includes(exception)
    );

    // Vérifier si aucun résultat n'est trouvé
    // console.log('filteredItems.length === 0:', filteredItems);

    if (filteredItems.length === 0) {
      this.noResults = true;
      this.showAllCitiesAndLocalities(); // Afficher toutes les villes/localités si aucun match
    } else {
      // this.notMerged = true;
      this.noResults = false;
      // this.mergeCitiesAndLocalities();
    }
    let hasMatch = item.name.toLowerCase().includes(term.toLowerCase());

    if (exception) {
      hasMatch = item.name.toLowerCase().includes(exception);
    }

    return hasMatch;
  }

  onSelectChange(selectedValue: any): void {
    const city = selectedValue?.split(',')[0]?.trim();
    const locality = selectedValue?.split(',')[1]?.trim();
    this.select.emit({ city, locality });
  }

  showAllCitiesAndLocalities(): void {
    if (!this.selectedRegion?.cities?.length || !this.searchTerm || this.skip)
      return;

    this.filteredItems = this.cities; // Afficher toutes les villes et localités

    this.skip = true;
    this.notMerged = true;
    setTimeout(() => {
      this.skip = false;
    }, 400);
  }
}
